/* eslint-disable no-unused-vars */
import * as S from './Tablecell.styled';
import { AppsBudgetDropDown } from 'assets/icons';

const sizes = {
  32: '32px',
  40: '40px',
  48: '48px',
  56: '56px',
  64: '64px',
  72: '72px',
};

export const Component = ({
  children,
  size,
  style,
  width,
  onClick,
  direction,
  value,
  hideSorting,
}) => {
  return (
    <S.TableContainer style={style} size={size} width={width} value={value}>
      <S.Content onClick={() => onClick(value)} direction={direction}>
        {children}
        {!hideSorting && <AppsBudgetDropDown style={{ minWidth: '8px' }} />}
      </S.Content>
    </S.TableContainer>
  );
};

export const TableCell = {
  Component,
  sizes,
};
